import { useEffect, useState } from "react";
import {
    FileText,
    Save,
    X,
    ClipboardList
} from "lucide-react";

import {
    getJobInstructions,
    createJobInstructions,
    updateJobInstructions
} from "../../services/jobInstructionService";

import "./JobInstructionModal.scss";

export default function JobInstructionsModal({
    isOpen,
    onClose,
    jobId,
    userType,
}) {

    const isCompany = userType === "Company";

    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);

    const [hasInstructions, setHasInstructions] = useState(false);

    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");

    useEffect(() => {
        if (!isOpen) return;

        loadInstructions();
    }, [isOpen]);

    async function loadInstructions() {
        setLoading(true);
        try {
            const data = await getJobInstructions(jobId);

            setHasInstructions(true);
            setTitle(data.title);
            setDescription(data.description);
        } catch {
            setHasInstructions(false);
            setTitle("");
            setDescription("");
        } finally {
            setLoading(false);
        }
    }

    async function handleSave() {
        setSaving(true);
        try {
            const payload = {
                title,
                description
            };
            if (hasInstructions) {
                await updateJobInstructions(jobId, payload);
            } else {
                await createJobInstructions(jobId, payload);
                setHasInstructions(true);
            }
            onClose();
        } catch (err) {
            alert(
                err.response?.data?.message ??
                "Erro ao salvar instruções."
            );
        } finally {
            setSaving(false);
        }
    }

    if (!isOpen) return null;

    return (
        <div
            className="job-instructions-overlay"
            onClick={onClose}
        >
            <div
                className="job-instructions-modal"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="job-instructions-header">
                    <div className="job-instructions-header__left">
                        <div className="job-instructions-icon">
                            <ClipboardList size={22} />
                        </div>
                        <div>
                            <h2>
                                {isCompany
                                    ? "Instruções da vaga"
                                    : "Orientações da empresa"}
                            </h2>
                            <span>
                                {isCompany
                                    ? "Informe tudo o que o profissional precisa saber."
                                    : "Leia atentamente antes de iniciar seu turno."}
                            </span>
                        </div>
                    </div>
                    <button
                        className="job-instructions-close"
                        onClick={onClose}
                    >
                        <X size={18} />
                    </button>
                </div>

                <div className="job-instructions-body">
                    {loading ? (
                        <div className="job-instructions-loading">
                            Carregando...
                        </div>
                    ) : (
                        <>
                            <div className="job-instructions-field">
                                <label>
                                    <FileText size={16} />
                                    Título
                                </label>
                                <input
                                    type="text"
                                    placeholder="Ex.: Chegada ao estabelecimento"
                                    value={title}
                                    onChange={(e) => setTitle(e.target.value)}
                                    disabled={!isCompany}
                                />
                            </div>

                            <div className="job-instructions-field">
                                <label>
                                    Descrição
                                </label>

                                <textarea
                                    rows={10}
                                    placeholder="Explique todas as orientações para o profissional..."
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                    disabled={!isCompany}
                                />
                            </div>
                        </>
                    )}
                </div>

                <div className="job-instructions-footer">
                    <button
                        className="job-btn job-btn-secondary"
                        onClick={onClose}
                    >
                        Fechar
                    </button>

                    {isCompany && (
                        <button
                            className="job-btn job-btn-primary"
                            onClick={handleSave}
                            disabled={saving}
                        >
                            <Save size={17} />
                            {saving
                                ? "Salvando..."
                                : hasInstructions
                                    ? "Atualizar"
                                    : "Salvar"}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
}